import type { Task } from "./schema";

/**
 * Whether a task was done between `start` and `end` (ms): finished then, or — a repeating task, which never
 * finishes — done then according to its history (skips do not count). The one rule for *Done today* in the List
 * and in the day review (UI cleanup U2: the List counted only finished tasks).
 */
export function doneBetween(task: Task, start: number, end: number): boolean {
  if (task.doneAt) {
    const at = Date.parse(task.doneAt);
    if (at >= start && at < end) return true;
  }
  const h = task.props["rec.history"] as unknown;
  return (
    Array.isArray(h) &&
    (h as { at?: string; skipped?: boolean }[]).some((e) => {
      if (!e || e.skipped || typeof e.at !== "string") return false;
      const at = Date.parse(e.at);
      return at >= start && at < end;
    })
  );
}
